import config from 'veui/managers/config'

config.defaults(
  {
    ui: {
      style: {
        values: ['alt']
      }
    }
  },
  'fieldset'
)
